var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82805 13.467L1.81389 13.4811C1.62264 13.0632 1.50222 12.5886 1.45264 12.0645C1.50222 12.5815 1.6368 13.049 1.82805 13.467Z",
    fill: "#8412D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37577 7.35409C7.30683 7.35409 8.06161 6.59932 8.06161 5.66826C8.06161 4.7372 7.30683 3.98242 6.37577 3.98242C5.44471 3.98242 4.68994 4.7372 4.68994 5.66826C4.68994 6.59932 5.44471 7.35409 6.37577 7.35409Z",
    fill: "#8412D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4679 1.41699H5.53204C2.95371 1.41699 1.41663 2.95408 1.41663 5.53241V11.4682C1.41663 12.2403 1.55121 12.9132 1.81329 13.4799C2.42246 14.8257 3.72579 15.5837 5.53204 15.5837H11.4679C14.0462 15.5837 15.5833 14.0466 15.5833 11.4682V9.84616V5.53241C15.5833 2.95408 14.0462 1.41699 11.4679 1.41699ZM14.4287 8.85449C13.8762 8.37991 12.9837 8.37991 12.4312 8.85449L9.48454 11.3832C8.93204 11.8578 8.03954 11.8578 7.48704 11.3832L7.24621 11.1849C6.74329 10.7457 5.94288 10.7032 5.37621 11.0857L2.72704 12.8637C2.57121 12.467 2.47913 12.0066 2.47913 11.4682V5.53241C2.47913 3.53491 3.53454 2.47949 5.53204 2.47949H11.4679C13.4654 2.47949 14.5208 3.53491 14.5208 5.53241V8.93241L14.4287 8.85449Z",
    fill: "#8412D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.34d49233.svg";
export { ForwardRef as ReactComponent };